import React from "react";
import PropTypes from "prop-types";

const DependenciesBodyTemplate = ({ children }) => {
  return <div className="object_subtasks task_dependencies">{children}</div>;
};

DependenciesBodyTemplate.propTypes = {
  children: PropTypes.any,
};

export default DependenciesBodyTemplate;
